import { TIPOS_CASO, bdDeOficial } from "./conciliacionBancaria";

// Casos que Financieros publica a cada plantel (tblmultipagos_casos) y lo que el cajero puede hacer con ellos.
// El servidor (cMultipagosCasos.php) decide que accion aplica a cada tipo y toma del banco los datos del cobro;
// aqui solo se arma lo que se publica y lo que muestra la pantalla.

// Un mismo caso (tipo + movimiento del banco + orden) no se publica dos veces mientras siga abierto
export const identidadDeCaso = (c) => [c.tipo, c.clave || "", c.orden || ""].join("|");

// Los que corrige el plantel (los pagos en linea los corrige Sistemas). Los que coinciden exactamente con una orden
// no se publican: se validan con el banco. Tampoco la orden pagada en partes que el banco confirma.
export const casosPublicables = (casos, oficial = "") =>
  casos.filter((c) => TIPOS_CASO[c.tipo] && TIPOS_CASO[c.tipo].quien === "PLANTEL" && c.oficial && !c.automatico && !c.seConfirma && (!oficial || c.oficial === oficial));

export const casoParaPublicar = (c) => ({
  identidad: identidadDeCaso(c),
  id_plantel: bdDeOficial(c.oficial),
  tipo: c.tipo,
  fuente: c.fuente,
  clave_movimiento: c.clave || "",
  id_intencion: c.orden || null,
  datos: {
    fecha: c.fecha, hora: c.hora, importe: c.importe, probable: c.probable, cuenta: c.cuenta,
    autorizacion: c.autorizacion, referencia: c.referencia, tecleado: c.tecleado, folioBanco: c.folioBanco, medio: c.medio,
    orden: c.orden, folio: c.folio, capturado: c.capturado, metodo: c.metodo, montoOrden: c.montoOrden, validada: c.validada,
    cajero: c.cajero, matricula: c.matricula, nota: c.nota, accion: c.accion,
    medioCobro: c.medioCobro, deLaValidacion: c.deLaValidacion, matriculaBanco: c.matriculaBanco, conceptosBanco: c.conceptosBanco, otra: c.otra,
    duplicadas: c.duplicadas || [], otras: c.otras || [], partes: c.partes || [], posibles: c.posibles || [], sospechosas: c.sospechosas || [],
  },
});

// Casos abiertos que el cruce de hoy ya no marca: ni su movimiento del banco ni su orden aparecen en ningun caso
// (tampoco como parte de un pago agrupado). Solo se juzgan los del periodo revisado.
export function casosAConfirmar(abiertos, casosActuales, periodo) {
  const claves = new Set(casosActuales.flatMap((c) => [c.clave, ...(c.partes || []).map((p) => p.clave)]).filter(Boolean));
  const ordenes = new Set(casosActuales.flatMap((c) => [c.orden, ...(c.otras || []).map((o) => o.orden)]).map((x) => String(x || "")).filter(Boolean));
  return abiertos.filter((k) => {
    const fecha = (k.datos && k.datos.fecha) || "";
    if (!fecha || fecha < periodo.inicio || fecha > periodo.fin) return false;
    if (k.clave_movimiento && claves.has(k.clave_movimiento)) return false;
    if (k.id_intencion && ordenes.has(String(k.id_intencion))) return false;
    return true;
  }).map((k) => Number(k.id));
}

export const ESTADOS_CASO = {
  PENDIENTE: { titulo: "Pendiente", color: "#c62828" },
  CORREGIDO: { titulo: "Corregido por el plantel", color: "#ef6c00" },
  RESPONDIDO: { titulo: "Respondido por el plantel", color: "#6a1b9a" },
  CONFIRMADO: { titulo: "Confirmado con el banco", color: "#2e7d32" },
  CERRADO: { titulo: "Cerrado por Financieros", color: "#555" },
};

// Botones del cajero. "pide": dato extra que debe escribir, ademas de la justificacion.
export const ACCIONES_CASO = {
  VALIDAR: { boton: "Validar", explica: "Se valida la orden con el cobro que dice el banco.", pide: null },
  LIGAR: { boton: "Ligar a una orden", explica: "Escribe el folio de la orden PENDIENTE del alumno (si no tiene, genérale una en Cobrar y vuelve). Se valida con el cobro que dice el banco.", pide: "folio_orden" },
  CORREGIR_DATO: { boton: "Corregir", explica: "Se cambia lo que se capturó por lo que dice el banco.", pide: null },
  CAMBIAR_METODO: { boton: "Corregir el método", explica: "Se cambia el método (y el dato capturado) por lo que dice el banco.", pide: null },
  ENCONTRE_TICKET: { boton: "Encontré el ticket", explica: "Escribe la autorización (TPV) o el folio (ventanilla) del comprobante. Solo se acepta si el banco tiene ese cobro.", pide: "dato" },
  CANCELAR_DUPLICADA: { boton: "Cancelar esta orden", explica: "La orden queda CANCELADA con la nota de que su pago ya está en la otra orden. El alumno no queda debiendo nada.", pide: null },
  DESHACER: { boton: "Deshacer validación", explica: "La orden regresa a PENDIENTE, como si no se hubiera validado.", pide: null },
  REASIGNAR: { boton: "Reasignar", explica: "El pago pasa a la orden PENDIENTE del otro alumno (mismo plantel y mismo importe) y esta orden regresa a PENDIENTE. Financieros recibe el aviso.", pide: "folio_orden" },
  RESPONDER: { boton: "Responder", explica: "No cambia nada en el sistema: Financieros lee tu explicación y decide.", pide: null },
};

export const MIN_JUSTIFICACION = 10;

// Que dato del comprobante va en "Encontré el ticket", segun como se valido la orden
export function datoDelComprobante(medioCobro) {
  if (medioCobro === "Ventanilla Banorte") return "el Folio de pago del comprobante de Banorte (20 dígitos, termina en 05446)";
  if (medioCobro === "Ventanilla BBVA") return "el folio del comprobante de BBVA";
  return "la autorización que imprimió el ticket de la TPV (6 caracteres)";
}

// Que revisar en un caso "probable": el sistema lo relaciono por hora, importe o matricula, no por el dato del banco
export function avisoProbable(d = {}) {
  const queDato = d.autorizacion ? `la autorización ${d.autorizacion}` : `el folio ${d.folioBanco}`;
  return `Es probable, no seguro: el sistema relacionó este cobro con la orden por la hora, el importe o la matrícula, no por la autorización ni el folio. Antes de corregir, revisa el comprobante del alumno: debe decir ${queDato}. Si no coincide, usa Responder.`;
}

// Ejemplos de justificacion, para que no se quede en "me equivoque"
export const EJEMPLO_JUSTIFICACION = {
  VALIDAR: "Ej.: el alumno pagó en ventanilla el 14/10 y no se había validado.",
  LIGAR: "Ej.: el alumno pagó con una ficha del sistema anterior; se le generó la orden 243193.",
  CORREGIR_DATO: "Ej.: capturé el número de afiliación de la terminal en lugar de la autorización del ticket.",
  CAMBIAR_METODO: "Ej.: el alumno pagó con TPV y lo validé como ventanilla.",
  ENCONTRE_TICKET: "Ej.: el alumno trajo su comprobante de Banorte del 08/10; se capturó la referencia en lugar del folio.",
  CANCELAR_DUPLICADA: "Ej.: el alumno pagó en línea y se le validó también la ficha de ventanilla con la misma autorización.",
  DESHACER: "Ej.: el alumno no tiene comprobante; la validación se hizo por error.",
  REASIGNAR: "Ej.: pagaron dos alumnos seguidos con la misma ficha; el ticket es del alumno de la orden 715 y se validó la 713.",
  RESPONDER: "Ej.: el alumno pagó de menos y el viernes trae el resto.",};
export const DIAS_HABILES_PLAZO = 5;
export const ESTADOS_ABIERTOS = ["PENDIENTE", "CORREGIDO", "RESPONDIDO"];

// "2026-10-22" + 5 dias habiles (lunes a viernes; los festivos no se descuentan, igual que el servidor) -> "2026-10-29"
export function fechaLimite(desdeIso, dias = DIAS_HABILES_PLAZO) {
  const [a, m, d] = desdeIso.split("-").map(Number);
  const f = new Date(Date.UTC(a, m - 1, d));
  let faltan = dias;
  while (faltan > 0) {
    f.setUTCDate(f.getUTCDate() + 1);
    const dia = f.getUTCDay();
    if (dia !== 0 && dia !== 6) faltan -= 1;
  }
  return f.toISOString().substring(0, 10);
}
